import React from 'react';
import { Sidebar } from './Sidebar';
import { DashboardHeader } from './DashboardHeader';

interface MainLayoutProps {
    children: React.ReactNode;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
    return (
        <div className="flex h-screen bg-[#F9FAFB] overflow-hidden">
            {/* Sidebar */}
            <Sidebar />

            {/* Content Area */}
            <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
                {/* Header */}
                <DashboardHeader />

                {/* Main Content */}
                <main className="flex-1 overflow-y-auto custom-scrollbar p-[24px]">
                    {children}
                </main>
            </div>
        </div>
    );
};
